import styled from 'styled-components';
import { colors } from 'styles/colors';

export const PictureBox = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

export const PictureButton = styled.button`
  padding: 0;
  margin: 0;
  background: ${colors.bg['white-0']};
  height: 100%;
  border: 1px dashed ${colors.stroke['sub-300']};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const DeleteButton = styled.button`
  border: none;
  padding: 10px;
  margin-left: 20px;
  cursor: pointer;
  background-color: transparent;
`;

export const PictureInputContainer = styled.div`
  height: 114px;
  padding: 12px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  background-color: ${colors.bg['white-0']};
  border: 1px solid ${colors.stroke['sub-300']};

  & > span {
    font-weight: 700;
    font-size: 12px;
    color: ${colors.Blue700};
    line-height: 130%;
  }
`;
